export default "__VITE_ASSET__7c834b87__"